import type { ButtonHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

// 어두운 레일 위 아이콘 버튼 — 로그아웃·의견 보내기가 같은 글자색(rail-muted→rail-strong)·hover 배경(rail-active)을 쓴다(Button variant 엔 레일 색이 없다).
const RailIconButton = ({ className, type = "button", ...rest }: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    className={cn("tap-target relative rounded-md p-1.5 text-rail-muted hover:bg-rail-active hover:text-rail-strong disabled:opacity-50", className)}
    type={type}
    {...rest}
  />
);

export default RailIconButton;
